var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TestFunctions "},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button"},on:{"click":_vm.doFn}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" "+_vm._s(_vm.$t('global.do'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }